import { PriceEditInfo } from '@/adapters/offline-mode';
import { roundMicrosToNearestWholeCent } from '@/utils/money';
import { SalesRepOverrideMode } from '@/enums';
import { useCallback } from 'react';
import { useUserContext } from '@/contexts/user-context';
import { useVariantPackInfoContext } from '@/contexts/variant-pack-info-context';

export const useCalculateVariantPackPrice = () => {
  const { selectedRestaurantRelationship } = useUserContext();
  const { getVariantPackInfo } = useVariantPackInfoContext();

  const calculateVariantPackPriceUsingPriceEdit = useCallback(
    (variantPackUUID: string, priceEditInfo: PriceEditInfo) => {
      if (priceEditInfo.type === SalesRepOverrideMode.PRICE) {
        return priceEditInfo.value;
      }

      if (priceEditInfo.type === SalesRepOverrideMode.GROSS_PROFIT) {
        if (priceEditInfo.value === null) {
          return null;
        }

        const variantPackInfo = getVariantPackInfo(variantPackUUID);
        const customerCostType =
          selectedRestaurantRelationship.customerCostType;
        if (
          !variantPackInfo ||
          !variantPackInfo.salesRepInfo ||
          !customerCostType ||
          !variantPackInfo.salesRepInfo.costMap[customerCostType]
        ) {
          return null;
        }

        const customerCostInMicros =
          variantPackInfo.salesRepInfo.costMap[customerCostType]!;

        return roundMicrosToNearestWholeCent(
          customerCostInMicros / (1 - priceEditInfo.value / 100),
        );
      }
    },
    [getVariantPackInfo, selectedRestaurantRelationship],
  );

  return { calculateVariantPackPriceUsingPriceEdit };
};
